import { deleted, downloadFilePost, get, post, put } from 'utils/api';

import { DataResponse } from '../response';
import { MASTER_DATA_API_URL } from 'utils/constants';

export type WasteGroupingContractModel = {
  stt: number;
  wasteGroupingContractId: string;
  wasteGroupingContractCode?: string | number;
  wasteGroup: string;
  wasteGroupingContractName: string;
  createdBy?: string;
  userName?: string;
  createdTime?: string;
  actived: boolean;
};

export type WasteGroupingContractSearchPayload = {
  wasteGroup?: string;
  wasteGroupingContractName?: string;
  actived?: boolean;
  activedOnly?: boolean;
  paging: {
    pageSize: number;
    pageIndex: number;
    orderBy?: string;
    orderByDesc?: string;
  };
};

export interface IWasteGroupingContractServices {
  search(data: WasteGroupingContractSearchPayload): Promise<DataResponse<Array<WasteGroupingContractModel>>>;
  create(data: Partial<WasteGroupingContractModel>): Promise<DataResponse<any>>;
  update(data: Partial<WasteGroupingContractModel>): Promise<DataResponse<any>>;
  getDetail(id: string): Promise<DataResponse<WasteGroupingContractModel>>;
  delete(id: string): Promise<DataResponse<any>>;
  export(data: WasteGroupingContractSearchPayload): Promise<void>;
  import(file: File): Promise<DataResponse<any>>;
}

export function createWasteGroupingContractServices(): IWasteGroupingContractServices {
  return {
    search: async (data) => {
      return (await post(MASTER_DATA_API_URL, 'wastegroupingcontract/search', data)).data;
    },
    create: async (data) => {
      return (await post(MASTER_DATA_API_URL, 'wastegroupingcontract/create', data)).data;
    },
    update: async (data) => {
      return (await put(MASTER_DATA_API_URL, 'wastegroupingcontract/update', data)).data;
    },
    getDetail: async (id) => {
      return (await get(MASTER_DATA_API_URL, `wastegroupingcontract/get/${id}`)).data;
    },
    delete: async (id) => {
      return (await deleted(MASTER_DATA_API_URL, `wastegroupingcontract/delete/${id}`)).data;
    },
    export: async (data) => {
      await downloadFilePost(MASTER_DATA_API_URL, 'wastegroupingcontract/export', data);
    },
    import: async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return (await post(MASTER_DATA_API_URL, 'wastegroupingcontract/import', formData)).data;
    },
  };
}

